/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
import Cookie from 'js-cookie';
import { $, $$ } from '@ok/sq';
import utils from '@common/utils';
import dayjs from 'dayjs';
import ws from './ws';
import logout from './logout';
import { initLoginDevTool } from './devTool';
import { initGA } from './ga';

import './index.less';

const DOWNLOAD_URL_IOS = 'https://itunes.apple.com/app/id1614786640';
const DOWNLOAD_URL_ANDROID =
  'https://play.google.com/store/apps/details?id=com.okinc.okcoin.jp';

// TODO: remove these (especially the "MutationObserver" below)
/*
查了下这个dialog是专属 @ok/Dialog 的问题，
理论上可以直接直接设一个css 就可以解决问题
解决方案：
.home-container:has(.ok-dialog) {
  z-index: 12;
}
由于时间原因，未测试所有页面的有效性，如果没问题的话，可以直接替换掉下面的代码
*/
// Temporarily handle dialog-level bug
function handleDialogOpen() {
  $('.home-container').css('z-index', 12);
  $('#newHeader').css('opacity', 0);
}

function handleDialogClose() {
  $('.home-container').css('z-index', 1);
  $('#newHeader').css('opacity', 1);
}

function handleDialogZIndex() {
  const observer = new MutationObserver((mutationRecords) => {
    mutationRecords.forEach((mutationRecord) => {
      mutationRecord.addedNodes.forEach((dom) => {
        if (dom?.classList?.contains('ok-dialog')) {
          handleDialogOpen();
        }
      });

      mutationRecord.removedNodes.forEach((dom) => {
        if (dom?.classList?.contains('ok-dialog')) {
          handleDialogClose();
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true, // observe direct children
    subtree: true, // and lower descendants too
    characterDataOldValue: true, // pass old data to callback
  });
}

(function (window, document) {
  initLoginDevTool();

  window.fz(window.okGlobal, 'wsConnectUrl', ws.getConnectUrl());

  // init seo monitor instance
  window.seoMonitor = window.utils?.monitor?.newInstance({
    site: 'okjp',
    product: 'seo',
    withPV: true,
  });

  const source = {
    BUYSELL: 'buysell',
    HOMEPAGE_NAVIGATION: 'homepage_navigation',
    TRADE: 'trade',
    RECURRING_BUY: 'recurringbuy',
    EARN: 'earn',
    REFERRAL: 'referral',
    SIGNUP: 'signup',
    LOGIN: 'login',
    HOMEPAGE_BUTTON: 'homepage_button',
    HOMEPAGE_FIRST_SCREEN_BUTTON: 'homepage_logout_first_screen_singup_button',
    OTHERS: 'others',
    NOLOGIN_LINKTO_SALE: 'homepage_logout_first_screen_token_area',
    LOGIN_LINKTO_SALE: 'homepage_logged_crypotolist',
  };

  const eventTracing = {
    source,
    tracingSource: 'tracingSource',
    pageMappings: {
      '/sale': source.BUYSELL,
      '/spot/trade': source.TRADE,
      '/recurring/buy': source.RECURRING_BUY,
      '/pages/recurring': source.RECURRING_BUY,
      '/staking': source.EARN,
      '/referral': source.REFERRAL,
      '/account/register': source.SIGNUP,
      '/account/login': source.LOGIN,
    },

    putSource(value) {
      sessionStorage.setItem(this.tracingSource, value);
    },

    getSource() {
      const otherTypes = ['reload', 'back_forward'];
      const navigationType =
        performance.getEntriesByType('navigation')[0]?.type;
      if (otherTypes.includes(navigationType)) {
        return this.source.OTHERS;
      }

      if (sessionStorage.getItem(this.tracingSource)) {
        const tempSource = sessionStorage.getItem(this.tracingSource);
        sessionStorage.removeItem(this.tracingSource);
        return tempSource;
      }
      const { referrer } = document;
      const key = Object.keys(this.pageMappings).find((item) => {
        return referrer.includes(item);
      });
      return this.pageMappings[key] || source.HOMEPAGE_NAVIGATION;
    },
  };

  window.okGlobal.eventTracing = eventTracing;

  // url and tracing point
  const headerTracingMap = {
    '/spot/trade': 'web_navigation_trade_click',
    '/staking': 'web_navigation_earn_staking_click',
    '/markets/list': 'web_markets_markets_click',
    '/markets/news': 'web_markets_news_click',
    '/earn/flash-deals': 'web_navigation_earn_flashdeals_click',
    '/recurring-buy': 'web_navigation_recurringbuy_click',
    '/pages/recurring': 'web_navigation_recurringbuy_click',
    '/account/login': 'web_navigation_login_click',
    '/account/register': 'web_navigation_signup_click',
    '/sale': 'web_buysell_navigation_button',
    '/sections': 'web_navigation_activities_activities_click',
    '/btc-index': 'web_btc_index_navigation_button_click',
    '/account/referral': 'web_navigation_activities_referral_click',
  };

  // url and tracing point
  const footerTracingMap = {
    '/btc-index': 'web_btc_index_button_click',
  };

  /* language bar */
  (function () {
    const commonObj = {
      list: [],
      languageList: [
        {
          language: 'ja_JP',
          text: '日本語',
          mobileText: 'JP',
          className: 'ja',
        },
        {
          language: 'zh_CN',
          text: '简体中文',
          mobileText: 'CN',
          className: 'ch',
        },
        {
          language: 'en_US',
          text: 'English',
          mobileText: 'EN',
          className: 'en',
        },
      ],

      normalizeLocale(locale) {
        if (!locale || typeof locale !== 'string') {
          return '';
        }

        const normalizedLocale = locale.toLowerCase().replace(/-/g, '_');
        if (normalizedLocale === 'ja_jp' || normalizedLocale.startsWith('ja')) {
          return 'ja_JP';
        }
        if (normalizedLocale === 'zh_cn' || normalizedLocale.startsWith('zh')) {
          return 'zh_CN';
        }
        if (normalizedLocale === 'en_us' || normalizedLocale.startsWith('en')) {
          return 'en_US';
        }

        return '';
      },

      renderHeaderNoticeSub() {
        fetch(
          'https://support.okj.com/api/v2/help_center/ja/sections/59000095734553/articles.json?sort_order=desc&per_page=5'
        )
          .then((response) => response.json())
          .then((res) => {
            const { articles } = res;
            let noticeInner = '';
            if (articles.length) {
              for (let i = 0; i < articles.length; i++) {
                // News title format is maintained by operations colleagues
                // can not guarantee the format must be correct
                try {
                  const article = articles[i];
                  const [time, title] = article.title.split('】');
                  const createdTime = time.trim().slice(1).split('/').join('-');
                  noticeInner += `
                    <li>
                      <a
                        target="_blank"
                        href="${article.html_url}"
                      >
                      <div class="head-sub-li-div">
                        <div class="head-sub-title">${title}</div>
                        <div class="head-sub-time">${createdTime}</div>
                      </div>
                      </a>
                    </li>
                  `;
                } catch (err) {
                  console.log(err);
                }
              }
              const newNoticeTimestamp = Date.parse(articles[0].created_at);
              this.initNoticeBadge(newNoticeTimestamp);
            }
            $('#newHeader #noticeWrapper').html(noticeInner);
          })
          .catch(() => {});
      },

      // set tracing point
      setTracingPoint(key) {
        const match = Object.keys(headerTracingMap).filter((r) => {
          return key.includes(r);
        });
        if (match.length !== 0) {
          window.seoMonitor.act(headerTracingMap[match[0]]);
        }
      },

      // set footerTracing point
      setFooterTracingPoint(key) {
        const match = Object.keys(footerTracingMap).filter((r) => {
          return key.includes(r);
        });
        if (match.length !== 0) {
          window.seoMonitor.act(footerTracingMap[match[0]]);
        }
      },

      // bind mouse click addListener event
      initHandleHeaderTrack() {
        $$('#newHeader .login a').each((dom) => {
          $(dom).on('click', () => {
            eventTracing.putSource(source.HOMEPAGE_NAVIGATION);
          });
        });
        $$('#newHeader .head-link-sale a').each((dom) => {
          $(dom).on('click', () => {
            eventTracing.putSource(source.HOMEPAGE_NAVIGATION);
          });
        });
        $$('#newHeader .account a').each((dom) => {
          $(dom).on('click', () => {
            eventTracing.putSource(source.HOMEPAGE_NAVIGATION);
          });
        });
        $$('#newHeader a').each((dom) => {
          $(dom).on('click', (ele) => {
            this.setTracingPoint($(ele.currentTarget).attr('href'));
          });
        });
      },

      initNoticeBadge(timestamp) {
        const userLastViewNoticeTime =
          localStorage.getItem('userLastViewNoticeTime') || 0;
        if (timestamp > userLastViewNoticeTime) {
          $('#newHeader .notice-badge').css('visibility', 'visible');
        }
        $('#newHeader .notice-head-sub').on('click', () => {
          $('#newHeader .notice-badge').css('visibility', 'hidden');
          localStorage.setItem('userLastViewNoticeTime', Date.now());
        });
      },

      init() {
        this.renderHeaderNoticeSub();
        this.initHandleHeaderTrack();
        $('.download-icon').on('mouseenter', () => {
          window.seoMonitor.act('web_navigation_download_hover');
        });
        $('.cvbtn a').on('click', () => {
          // the track function trigger in login component willcomponent
          eventTracing.putSource(source.HOMEPAGE_BUTTON);
        });
        $('.operate-menu .notice-icon').on('mouseenter', () => {
          window.seoMonitor.act('web_homepage_navigation_notice_hover');
        });
        $('.operate-menu #noticeWrapper').on('click', () => {
          window.seoMonitor.act('web_homepage_navigation_notice_click');
        });
        $('.operate-menu .head-sub-link').on('click', () => {
          window.seoMonitor.act('web_homepage_navigation_notice_more_click');
        });
        $$('#footerContainer .footer-menu-box .f_list a').each((dom) => {
          $(dom).on('click', (ele) => {
            this.setFooterTracingPoint($(ele.currentTarget).attr('href'));
          });
        });
        $('.head-menu .head-more-menu').on('mouseenter', () => {
          window.seoMonitor.act('web_navigation_more_hover');
        });
        const qrImgUrl = `${window.okGlobal.cdnBaseUrl}/cdn/assets/imgs/common/okj-app-download-qr.png`;
        $('.qr-code-img').attr('src', qrImgUrl);

        const token = localStorage.getItem('token');

        if (token && token.length > 0 && token.indexOf('null') < 0) {
          const nickName = localStorage.getItem('nickName');
          const currentIsSub = localStorage.getItem('currentIsSub');
          if (currentIsSub == 1 || currentIsSub == '') {
            $('.isSub').css('display', 'none');
          }
          $$('.user-name').text(nickName);
          $$('.user-login-wrap').removeClass('hide');

          this.handleRecurringNavUrl();
          this.handleCarfMenuDisplay();
        } else {
          $$('.user-no-login-wrap').removeClass('hide');
        }

        let pathname = window.location.pathname;
        const pathnameArr = ['trade', 'marketList', 'trade'];
        pathname = pathname.replace('/', '');
        let index = pathnameArr.indexOf(pathname);
        if (index > 1) {
          index -= 2;
        }

        this.handleRkycCheck();
      },

      getLanguage(callback) {
        const cookieLocale = Cookie.get('locale');
        let lang = this.normalizeLocale(cookieLocale);
        let choose = {};
        const list = [];
        if (!lang) {
          lang = 'ja_JP';
          Cookie.set('locale', 'ja_JP', { path: '/' });
          window.location.reload();
          return;
        }

        for (let i = 0; i < commonObj.languageList.length; i++) {
          list.push(commonObj.languageList[i]);
          if (commonObj.languageList[i].language === lang) {
            choose = commonObj.languageList[i];
          }
        }

        if (typeof callback === 'function') {
          callback(choose, list);
        }
      },

      setLanguage(rel) {
        for (let i = 0; i < commonObj.languageList.length; i++) {
          if (commonObj.languageList[i].language === rel) {
            Cookie.set('locale', commonObj.languageList[i].language, {
              path: '/',
            });
            window.location.reload();
            break;
          }
        }
      },

      renderLanguage(languageList) {
        if (languageList.length === 0) {
          return;
        }

        let topLanguageListHtml = '';
        const topMobileLanguageListHtml = [];
        let i;
        for (i = 0; i < languageList.length; i++) {
          topLanguageListHtml += `
          <li rel="${languageList[i].language}">
            <a href="javascript:void(0);">
              <span class="${languageList[i].className}">${languageList[i].text}</span>
              <i class="${languageList[i].language} icon iconfont okds-checkmark hide"></i>
            </a>
          </li>
        `;
          topMobileLanguageListHtml.push(`
            <div rel="${languageList[i].language}" class="${languageList[i].language} language-btn">
              <a href="javascript:void(0);">${languageList[i].mobileText}</a>
            </div>`);
        }
        $('#topLanguageList').html(topLanguageListHtml);
        $('#topMobileLanguageList').html(
          topMobileLanguageListHtml.join('<div>/</div>')
        );
        $(`#topLanguageList .${window.okGlobal.locale}`).removeClass('hide');
        $(`#topMobileLanguageList .${window.okGlobal.locale}`).addClass(
          'active'
        );
      },

      renderChooseLanguage(choose) {
        const headerLanguageHtml = `<span class=${choose.className}></span>`;
        const $headerLanguage = $('#topLanguage a');
        $headerLanguage.html(`${headerLanguageHtml}${$headerLanguage.html()}`);
      },

      initFooterEvent() {
        $$('#footerContainer .menu-box .f_txt').each(function (dom) {
          $(dom).on('click', function () {
            const footerMenu = $(this).parent();
            const footerMenuBody = footerMenu.find('.f_list')[0];
            if (footerMenu.hasClass('active')) {
              footerMenu.removeClass('active');
              $(footerMenuBody).css('height', 0);
            } else {
              utils.transitionHeight(footerMenuBody, 300);
              footerMenu.addClass('active');
            }
          });
        });
      },

      handleRecurringNavUrl() {
        const { ont } = window.utils;
        ont.get('/v2/asset/transaction/plan/userHasPlan').then((res) => {
          const { data, code } = res.data;
          if (code === 0 && data.result) {
            $$('#newHeader a[data-type=recurringBuy]').each((element) =>
              $(element).attr('href', '/recurring-buy')
            );
            $$('.footer-menu-box a[data-type=recurringBuy]').each((element) =>
              $(element).attr('href', '/recurring-buy')
            );
          }
        });
      },

      handleCarfMenuDisplay() {
        const { ont } = window.utils;
        ont
          .get('/v3/users/security/profile')
          .then((res) => {
            const { data, code } = res.data;
            if (code === 0 && data.carfRequired) {
              // Get localized text based on current locale
              const locale =
                this.normalizeLocale(Cookie.get('locale')) || 'ja_JP';
              const carfMenuText =
                {
                  ja_JP: '届出書の提出',
                  zh_CN: '提交特定交易从事者申报书',
                  en_US: 'Submit Notification Form',
                }[locale] || '届出書の提出';

              const menuItemHtml = `<li><a href="/account/users/carfForm">${carfMenuText}</a></li>`;

              // Desktop menu - insert after "基本情報/基本信息"
              const basicUserSettingItem = $(
                '#newHeader .user-info .head-sub a[href="/account/users"]'
              ).parent();
              if (basicUserSettingItem.length) {
                basicUserSettingItem.after(menuItemHtml);
              }

              // Mobile drawer menu - insert after "基本情報/基本信息"
              const mobileBasicUserSettingItem = $(
                '.header-drawer-box .user-info .head-sub a[href="/account/users"]'
              ).parent();
              if (mobileBasicUserSettingItem.length) {
                mobileBasicUserSettingItem.after(menuItemHtml);
              }
            }
          })
          .catch(() => {
            // Silently fail - CARF status will be fetched on next page load
          });
      },

      handleRkycCheck() {
        const currentUrl = window.location.href;
        const currentDate = dayjs(Date.now());
        const isUsersVerification = currentUrl.includes(
          '/account/users/verification'
        );
        const lastJumpType = localStorage.getItem('REKYC_JUMP_TYPE');
        const lastJumpTimestamp = localStorage.getItem('REKYC_JUMP_TIMESTAMP');
        // KYC页面不校验跳转(五分钟后再校验为佳)
        if (isUsersVerification) {
          setTimeout(() => {
            this.handleRkycCheck();
          }, 5 * 60 * 1000);
          return;
        }
        // 24小时内跳转过的不校验跳转(五分钟后再校验为佳)
        if (
          lastJumpType?.length &&
          lastJumpTimestamp?.length &&
          currentDate.valueOf() <
            Number(lastJumpTimestamp) + 24 * 60 * 60 * 1000
        ) {
          setTimeout(() => {
            this.handleRkycCheck();
          }, 5 * 60 * 1000);
          return;
        }
        const { ont } = window.utils;
        ont.get('/v3/users/rekyc/info').then((res) => {
          const { data, code } = res.data;
          if (code === 0) {
            const rekycConfig = data;
            if (typeof rekycConfig?.reKycType === 'number') {
              // TODO 需要判断到底有没有提交过，已经提交过的不再弹窗
              if (rekycConfig?.reKycType === 0) {
                const specifiedStartDate = dayjs(rekycConfig?.notifyDate);
                const specifiedEndDate = dayjs(rekycConfig?.expireDate);
                // 在留卡即将过期
                console.log('在留満了');
                if (
                  currentDate.valueOf() >=
                    specifiedStartDate.clone().valueOf() &&
                  currentDate.valueOf() <
                    specifiedEndDate.clone().add(1, 'day').valueOf()
                ) {
                  localStorage.setItem(
                    'REKYC_JUMP_TYPE',
                    rekycConfig?.reKycType
                  );
                  localStorage.setItem('REKYC_JUMP_TIMESTAMP', Date.now() + '');
                  setTimeout(() => {
                    // 跳转到基本情报
                    window.location.href = '/account/users/verification';
                  }, 100);
                }
              } else {
                const specifiedDate = dayjs(rekycConfig?.expireDate);
                // 风险管理触发再KYC
                console.log('ODD');
                if (rekycConfig?.oddType === 1) {
                  // DD
                  if (
                    currentDate.valueOf() >=
                    specifiedDate.clone().subtract(10, 'day').valueOf()
                  ) {
                    localStorage.setItem(
                      'REKYC_JUMP_TYPE',
                      rekycConfig?.reKycType
                    );
                    localStorage.setItem(
                      'REKYC_JUMP_TIMESTAMP',
                      Date.now() + ''
                    );
                    setTimeout(() => {
                      // 跳转到基本情报
                      window.location.href = '/account/users/verification';
                    }, 100);
                  }
                } else if (rekycConfig?.oddType === 2) {
                  // EDD
                  if (
                    currentDate.valueOf() >=
                      specifiedDate.clone().subtract(30, 'day').valueOf() &&
                    currentDate.valueOf() <= specifiedDate.valueOf()
                  ) {
                    localStorage.setItem(
                      'REKYC_JUMP_TYPE',
                      rekycConfig?.reKycType
                    );
                    localStorage.setItem(
                      'REKYC_JUMP_TIMESTAMP',
                      Date.now() + ''
                    );
                    setTimeout(() => {
                      // 跳转到基本情报
                      window.location.href = '/account/users/verification';
                    }, 100);
                  }
                }
              }
            }
          }
          setTimeout(() => {
            this.handleRkycCheck();
          }, 24 * 60 * 60 * 1000);
        });
      },
    };

    document.addEventListener('DOMContentLoaded', () => {
      // 邀请页面没有Footer，所以需要单独处理
      commonObj.initFooterEvent();

      initGA();

      // eslint-disable-next-line promise/catch-or-return
      import('./userMigration').then((module) => {
        module.default();
      });

      if (!$('#headerContainer').length) {
        return;
      }

      commonObj.init();

      commonObj.getLanguage((choose, list) => {
        commonObj.renderLanguage(list);
        commonObj.renderChooseLanguage(choose);
      });

      // buy/sell menu navigation event
      // const menuClassNames = ['.head_menu', '.menu_sp'];
      // menuClassNames.forEach((cx) => {
      //   $(`${cx} li`)
      //     .first()
      //     .on('click', () => {
      //       window.seoMonitor.act('web_buysell_navigation_button');
      //     });
      // });

      $$('#topLanguageList li').each((dom) => {
        $(dom).on('click', () => {
          const rel = $(dom).attr('rel');
          commonObj.setLanguage(rel);
        });
      });

      $$('#topMobileLanguageList .language-btn').each((dom) => {
        $(dom).on('click', () => {
          const rel = $(dom).attr('rel');
          commonObj.setLanguage(rel);
        });
      });

      $('.header-drawer-box .download-box a').attr(
        'href',
        utils.isIOS() ? DOWNLOAD_URL_IOS : DOWNLOAD_URL_ANDROID
      );

      // 嵌入app里时，去掉网页端注销功能，由app端注销同步
      const agent = window.navigator.userAgent.toLowerCase();
      if (agent.indexOf('okex') > -1 && agent.indexOf('electron') === -1) {
        $('.logout').addClass('hide');
      }

      $$('#newHeader .logout').each((dom) => {
        $(dom).on('click', (e) => {
          e.preventDefault();
          logout();
        });
      });

      /** special menu bar */
      $('#headerMenuBtn').on('click', function () {
        $('body').css('overflow', 'hidden');
        $('.header-drawer-box').addClass('active');
      });

      $('.header-drawer-close-button').on('click', function () {
        $('body').css('overflow', 'auto');
        $('.header-drawer-box').removeClass('active');
      });

      $('.header-drawer-mask').on('click', function () {
        $('body').css('overflow', 'auto');
        $('.header-drawer-box').removeClass('active');
      });

      $$('.header-menu-box .sub').each((dom) => {
        $(dom).on('click', function () {
          const headSubEle = this.querySelector('.head-sub');

          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(headSubEle).css('height', 0);
          } else {
            $(this).addClass('active');
            utils.transitionHeight(headSubEle, 300);
          }
        });
      });

      const pathname = window.location.pathname;
      if (
        window.React &&
        !utils.isLogin() &&
        pathname.indexOf('/account') === -1
      ) {
        import('@ok/okj-common/lib/login-method').then(
          ({ authGooglePopup }) => {
            authGooglePopup().catch((err) => {
              console.log(err);
            });
          }
        );
      }

      handleDialogZIndex();
    });
  })();
})(window, document);
